<template>
    <layout class="report-history-wrapper">
        <van-list
                class="report-list"
                v-model="loading"
                :finished="finished"
                @load="onLoad"
                finished-text="没有更多了">
            <div v-for="item in list" :key="item.id" class="report-item" @click="handleDetail(item)">
                <div class="report-date">{{item.reportDate}}</div>
                <div class="report-address">检测地址：{{item.examineAddress}}</div>
                <div class="member-wrapper">
                    <span class="member-name">{{item.memberName}}</span><van-icon name="arrow" color="#CECECE" size="18px"/>
                </div>
            </div>
        </van-list>
        <div class="bottom-button-wrapper"><button class="submit-button" @click="handleUpload">上传数据</button></div>
    </layout>
</template>

<script>
    export default {
        name: "ReportHistory",
        data() {
            return {
                loading: false,
                finished: false,
                page: {
                    current: 1,
                    size: 10
                },
                list: [],
            }
        },
        methods: {
            onLoad() {
                this.loadReportPage(this.page.current + 1);
            },

            handleUpload() {
                this.$router.push('/addReport')
            },

            handleDetail(item) {
                this.$router.push('/reportDetail/' + item.id)
            },

            async loadReportPage(current) {
                this.loading = true;
                try {
                    let {data} = await this.$req.getReportPage({
                        size: this.page.size,
                        current: current
                    });
                    data.records.forEach(item => {
                        this.list.push(item);
                    });

                    this.page.current = data.current;
                    if (this.list.length >= data.total) {
                        this.finished = true;
                    }
                } catch (e) {
                    //TODO
                } finally {
                    this.loading = false;
                }
            }
        },
        mounted() {
            this.loadReportPage(this.page.current)
        }
    }
</script>

<style scoped>

</style>